import { S } from '../regureStyles';
import MetricCard from './MetricCard';

// Trend values are period-over-period deltas computed from real historical
// snapshots. The dashboard endpoint doesn't return those yet; rather than
// render hardcoded '+12' / '-2.1d' / '+5' / '+0.3%' phantoms, we omit the
// trend chip until the API supplies one. The MetricCard component already
// treats null trend as "no chip".
const MetricCards = ({ t, loading, openClaims, metricFlash, avgCycleDays, pendingReviews, complianceScore }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
      <MetricCard
        label={t('dashboard.activeClaims')}
        value={loading ? '—' : openClaims !== null ? String(openClaims) : '—'}
        /* Neutral and truthful. This read "open, review, investigation,
           negotiation" — four statuses, under a metric that counts all nine
           in OPEN_STATUSES. Those four total 39 of MOK's 72, so the caption
           described a different population from the number above it.
           Enumerating all nine would be accurate and unreadable, and a second
           handwritten list would drift from the canonical set again the next
           time a status is added. The metric itself is unchanged. */
        sub={t('dashboard.claimsStatuses')}
        icon='shield'
        color={S.burgundy}
        flash={metricFlash.openClaims}
      />
      <MetricCard
        label={t('dashboard.avgCycleTime')}
        value={loading || avgCycleDays == null ? '—' : `${avgCycleDays}d`}
        sub={t('dashboard.daysPerClaim')}
        icon='clock'
        color='#3b82f6'
      />
      <MetricCard
        label={t('dashboard.pendingReviews')}
        value={loading ? '—' : pendingReviews !== null ? String(pendingReviews) : '—'}
        sub={t('dashboard.requireActionToday')}
        icon='alert-circle'
        color='#f59e0b'
        flash={metricFlash.pendingReviews}
      />
      <MetricCard
        label={t('dashboard.complianceScore')}
        value={loading ? '—' : complianceScore !== null ? `${complianceScore}%` : '—'}
        sub={t('dashboard.auditRequirementsMet')}
        icon='check-circle'
        color='#10b981'
      />
    </div>
  );
};

export default MetricCards;
